import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import { FormContainer, Treturn, useFetch } from "@4uhub/lib4uhub";

import {
  createBanner,
  getBannerById,
  updateBannerById,
} from "../../../../../services/banners.service";
import { TBannerForm, bannerSchema } from "./BannerSchema";

import { BannerFields } from "./BannerFields";

const translationPath = "page.register.banners.";

const Banner = () => {
  const { t } = useTranslation();
  const [bannersFilesId, setBannersFilesId] = useState<string[]>();
  let deleteFilesList: string[] = [];

  const { sendRequest: save, loading: sLoading } = useFetch(createBanner);

  const { sendRequest: update, loading: uLoading } = useFetch(updateBannerById);

  const { sendRequest: get, loading: gLoading } = useFetch(getBannerById);

  const handleSave = (v: TBannerForm) => {
    const allMediaFiles = [];

    if (v.bannerMobileMediaFile) {
      allMediaFiles.push({ file: v.bannerMobileMediaFile });
    }
    if (v.bannerMediaFile) {
      allMediaFiles.push({ file: v.bannerMediaFile });
    }
    const saveFilesIds = allMediaFiles.filter((media) =>
      media.file ? !bannersFilesId?.includes(media.file.id!) : ""
    );

    return save({
      alternativeText: v.alternativeText,
      enable: v.enable,
      name: v.name,
      title: v.title,
      bannerLocals: v.bannerLocals.map((local) => local.id),
      siteApps: v.siteApps.map((siteApp) => siteApp.id),
      mediaFilesIds: saveFilesIds.map((media) =>
        media.file ? media.file.id! : ""
      ),
      languageId: v.language.id,
      displayOrder: +v.displayOrder,
      deleteMediaFilesIds: deleteFilesList,
    });
  };

  const updateHandler = (v: TBannerForm, id: string) => {
    const allMediaFiles = [];
    if (v.bannerMobileMediaFile) {
      allMediaFiles.push({ file: v.bannerMobileMediaFile });
    }
    if (v.bannerMediaFile) {
      allMediaFiles.push({ file: v.bannerMediaFile });
    }
    const updateFilesIds = allMediaFiles.filter((media) =>
      media.file ? !bannersFilesId?.includes(media.file.id!) : ""
    );
    return update({
      item: {
        ...v,
        alternativeText: v.alternativeText,
        enable: v.enable,
        name: v.name,
        title: v.title,
        bannerLocals: v.bannerLocals.map((local) => local.id),
        siteApps: v.siteApps.map((siteApp) => siteApp.id),
        mediaFilesIds: updateFilesIds.map((media) =>
          media.file ? media.file.id! : ""
        ),
        languageId: v.language.id,
        displayOrder: +v.displayOrder,
        deleteMediaFilesIds: deleteFilesList,
      },
      id: id,
    });
  };

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TBannerForm>> => {
      const { data, success } = await get(id);

      if (success && data) {
        const filesId = data.bannerMediaFiles
          ? data.bannerMediaFiles.map((media) => media.id || "")
          : [];
        if (filesId) setBannersFilesId(filesId);

        const bannerMobile = data.bannerMediaFiles.find(
          (media) => media.mediaType?.code === "2"
        );

        const bannerFile = data.bannerMediaFiles.find(
          (media) => media.mediaType?.code === "1"
        );

        return {
          data: {
            ...data,
            bannerMediaFile: bannerFile
              ? {
                  id: bannerFile.id,
                  cdnDomain: bannerFile.cdnDomain,
                  fileName: bannerFile.fileName,
                  filePath: bannerFile.filePath,
                  fileSize: bannerFile.fileSize,
                  isPublic: bannerFile.isPublic,
                  mediaType: bannerFile.mediaType,
                  mediaTypeId: bannerFile.mediaTypeId,
                  mimeType: bannerFile.mimeType,
                }
              : null,
            bannerMobileMediaFile: bannerMobile
              ? {
                  id: bannerMobile.id,
                  cdnDomain: bannerMobile.cdnDomain,
                  fileName: bannerMobile.fileName,
                  filePath: bannerMobile.filePath,
                  fileSize: bannerMobile.fileSize,
                  isPublic: bannerMobile.isPublic,
                  mediaType: bannerMobile.mediaType,
                  mediaTypeId: bannerMobile.mediaTypeId,
                  mimeType: bannerMobile.mimeType,
                }
              : null,

            displayOrder: data.displayOrder ? data.displayOrder.toString() : "",
          },
          success: true,
        };
      }
      return {
        data: null,
        success: false,
      };
    },
    [get]
  );

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TBannerForm>
      saveFunction={handleSave}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "banner")}
      schema={bannerSchema}
      subtitle={t(translationPath + "new_banner")}
      subtitleWatchField={"name"}
      fields={() => <BannerFields deleteFilesList={deleteFilesList} />}
    />
  );
};

export default Banner;
